import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Card from "../../../components/Card";
import Fondo from "../../../images/modulo12/fondoperiodico.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad2Actividad8.mp3";

const Actividad9 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "respetar" },
    ans2: { value: "", valid: "", correctValue: "conversación" },
    ans3: { value: "", valid: "", correctValue: "acuerdo" },
    ans4: { value: "", valid: "", correctValue: "derechos" },
  });
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[10];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[9].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[9].path}`,
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[11].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[11].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="mb-0">
        <li>
          Ahora escribirás una buena noticia, que nos muestra un caso de lucha
          contra la discriminación.
        </li>
        <li>
          Completa la noticia con las palabras del recuadro y pon la fecha de
          hoy.
        </li>
        <li>
          Para terminar, en una hoja, haz un dibujo que acompañe la noticia.{" "}
        </li>
      </ul>
      <div className="row">
        <div className="col-lg-10 col-12">
          <Card>
            <div className="d-flex flex-wrap justify-content-around">
              <div className="m-1">conversación</div>
              <div className="m-1">acuerdo</div>
              <div className="m-1">derechos</div>
              <div className="m-1">respetar</div>
            </div>
          </Card>
          <div
            className="p-5"
            style={{
              backgroundImage: `url(${Fondo})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
            }}
          >
            <p>Fecha: ________/________/________</p>
            <h4>Se soluciona el caso de la APAFA</h4>
            <p>
              La niña que no se pudo matricular en el colegio por no haber
              pagado la APAFA fue con su mamá a la Defensoría del Pueblo. Allí
              denunciaron el caso y pidieron ayuda.
            </p>
            <p>
              Dos funcionarios de la Defensoría visitaron el colegio para
              comprobar que se estaban cumpliendo las normas. “La matrícula es
              gratuita”, dijeron. “Hay que{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />{" "}
              las leyes. Hemos tenido una{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />{" "}
              con la directora del colegio y hemos llegado a un{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans3.valid
                }
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />
              . La niña asistirá al colegio y, cuando puedan, sus padres pagarán
              la cuota de APAFA”.
            </p>
            <p>
              “Me alegro mucho de que se hayan cumplido nuestros
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans4.valid
                }
                value={answers.ans4.value}
                onChange={(event) => handleAnswers(event, "ans4")}
              />
              ”, dijo la madre de la niña.
            </p>
          </div>
        </div>
        <div className="col-md-10 col-12">
          <button
            className={`btn float-end mt-4 btn-${modulo12.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea las tres indicaciones. Pídale a un niño o niña que lea en voz
            alta las palabras del recuadro. Asegúrese de que comprenden las
            palabras. Pídales que elaboren oralmente oraciones con estas
            palabras. Ahora, déles un tiempo para que completen la noticia y
            luego, revísela con ellos. Una vez terminada la revisión, lea toda
            la noticia en voz alta.
          </li>
          <li>
            Cierre la actividad señalando que es muy importante tomar acciones
            concretas ante casos de discriminación. Para ello, es importante
            mantenernos informados sobre cuáles son las instituciones en donde
            podemos denunciarlos. Por ejemplo, en el caso de la APAFA, la
            familia denunció el caso ante la Defensoría del Pueblo.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
